export const DATIQ_RULE_CONDITION_NAME_SUFFIX: string = 'ConditionEvaluator';
export const datiqRuleConditionName: (type: string) => string = (
    type: string
) => `${type}${DATIQ_RULE_CONDITION_NAME_SUFFIX}`;
export const DATIQ_RULE_CONDITION_NOT_FOUND_DEFAULT: boolean = false;
